var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 50,
    rx: 4,
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.593637,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4194 4.08389L12.8458 4.08203C11.4756 4.08203 10.7834 4.21843 10.0631 4.61151C9.39997 4.97341 8.87355 5.51058 8.51889 6.18727C8.15936 6.87325 8.01894 7.53429 8.00182 8.75613L8.00042 13.776H0V15.8168H35V13.776H28V9.02675C28 7.6286 27.8663 6.92225 27.4811 6.18727C27.1265 5.51058 26.6 4.97341 25.9369 4.61151C25.2646 4.24464 24.6168 4.10136 23.4194 4.08389ZM12.6272 6.12411L23.1542 6.12294C24.2224 6.12294 24.6027 6.19788 24.9937 6.41122C25.3083 6.58291 25.5492 6.82876 25.7175 7.1498L25.7602 7.23538C25.9095 7.55045 25.9778 7.89026 25.9953 8.60057L26 9.02684V13.2658H10V9.02684C10 7.93678 10.0734 7.54871 10.2825 7.1498C10.4508 6.82876 10.6917 6.58291 11.0063 6.41122C11.3693 6.21312 11.7232 6.13435 12.6272 6.12411Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/BedIcon.af907efd.svg";
export { ForwardRef as ReactComponent };